const mutations = {
  SET_CARD_TYPE: (state, type) => {
    state.type = type
  },
  SET_CARD_BRAND: (state, brand) => {
    state.brand = brand
  },
  SET_SELECTED_TYPE: (state, selectedCardType) => {
    state.selectedCardType = selectedCardType
  },
  SET_REQUEST_INFO: (state, requestingInfos) => {
    state.requestingInfos = requestingInfos
  },
}

export default mutations
